<script lang="ts">
	import { Icon } from '$lib/ui/atoms/Icon';
	import { CircleCheck, Info, Loader2, OctagonX, TriangleAlert } from '@lucide/svelte';

	import { Toaster as Sonner, type ToasterProps as SonnerProps } from 'svelte-sonner';
	import { mode } from 'mode-watcher';

	let { ...restProps }: SonnerProps = $props();
</script>

<Sonner
	theme={mode.current}
	class="toaster group"
	style="--normal-bg: var(--color-popover); --normal-text: var(--color-popover-foreground); --normal-border: var(--color-border);"
	{...restProps}
	>{#snippet loadingIcon()}
		<Icon icon={Loader2} size="sm" class="animate-spin" />
	{/snippet}
	{#snippet successIcon()}
		<Icon icon={CircleCheck} size="sm" />
	{/snippet}
	{#snippet errorIcon()}
		<Icon icon={OctagonX} size="sm" />
	{/snippet}
	{#snippet infoIcon()}
		<Icon icon={Info} size="sm" />
	{/snippet}
	{#snippet warningIcon()}
		<Icon icon={TriangleAlert} size="sm" />
	{/snippet}
</Sonner>
